import sendToPiwik from "../../../tv24/js/analyticsTools/sendToPiwik";
import getDFPBlock from "../utils/getDFPBlock";
import advDelayLoad from "../../../tv24/js/es6/adv/advDelayLoad";
import loadScript from "../../js/scripts/loadScript";

export default function (newsId, elemCount, newsIndex, opt) {
    let wrapperId = 'adv' + newsId + elemCount;
    let advWrapper = document.getElementById(wrapperId);

    if (opt.isMarketplace && (opt.subsiteName === 'education' || opt.subsiteName === 'sport') && newsIndex === 1) {
        if (advWrapper !== null && advWrapper.childNodes.length === 0) {
            advWrapper.remove();
        }

        return;
    }

    if (advWrapper !== null && advWrapper.childNodes.length === 0) {
        if(newsIndex === 1 && window.innerWidth >= 1024){
            sendToPiwik('render first adv within news (Adpartner)', 'call');

            document.getElementById(wrapperId).innerHTML = '<div id="adpartner-vunit-' + contentRollAdPartnerId + '"></div>\n' +
                '    <div id="adpartner-htmlunit-750"></div>';

            loadScript("https://a4p.adpartner.pro/vunit?id=" + contentRollAdPartnerId + "&" + Math.random());
            loadScript("https://a4p.adpartner.pro/htmlunit?id=750&" + Math.random());

            let trackShowingAdpartner = function () {
                sendToPiwik('render first adv within news (Adpartner)', 'show')
            };
            advDelayLoad(trackShowingAdpartner, wrapperId, '0px')
        } else if (newsIndex >= 2 && newsIndex <= 5) {
            if(window.innerWidth < 640){
                getDFPBlock('/56301415/24tv_in_news_mobile_1_(2-5)', [[1, 1], [300, 250]], wrapperId, '300px');
            } else {
                getDFPBlock('/56301415/24tv_in_news_desktop_1_(2-5)', [[1, 1], [580, 400]], wrapperId, '580px');
            }
        } else {
            if(advWrapper.offsetWidth < 610 && newsIndex >= 6){
                getDFPBlock('/56301415/24tv_in_news_mobile_first', [300, 250], wrapperId, '300px');
            } else if (advWrapper.offsetWidth < 610) {
                getDFPBlock('/56301415/24tv_in_news_mobile_1_1', [300, 250], wrapperId, '300px');
            } else {
                getDFPBlock('/56301415/24tv_in_news_desktop_1_(6-11)', [[1, 1], [580, 400]], wrapperId, '580px');
            }
        }
    }
}
